/**
 * API service for Scheduling module
 */
import { ScheduledReport } from './reportsApi';

/**
 * Scheduling service for managing report schedules
 */
export const schedulingApi = {
  /**
   * Create a new scheduled report
   */
  createSchedule: async (data: Partial<ScheduledReport>) => {
    const { scheduledReportsApi } = await import('./reportsApi');
    return await scheduledReportsApi.createScheduledReport(data);
  },

  /**
   * Update an existing schedule
   */
  updateSchedule: async (id: number, data: Partial<ScheduledReport>) => {
    const { scheduledReportsApi } = await import('./reportsApi');
    return await scheduledReportsApi.updateScheduledReport(id, data);
  },

  /**
   * Partial update a schedule
   */
  partialUpdateSchedule: async (id: number, data: Partial<ScheduledReport>) => {
    const { scheduledReportsApi } = await import('./reportsApi');
    return await scheduledReportsApi.partialUpdateScheduledReport(id, data);
  },

  /**
   * Delete a schedule
   */
  deleteSchedule: async (id: number) => {
    const { scheduledReportsApi } = await import('./reportsApi');
    return await scheduledReportsApi.deleteScheduledReport(id);
  },

  /**
   * Activate a schedule
   */
  activateSchedule: async (id: number) => {
    const { scheduledReportsApi } = await import('./reportsApi');
    return await scheduledReportsApi.activateScheduledReport(id);
  },

  /**
   * Deactivate a schedule
   */
  deactivateSchedule: async (id: number) => {
    const { scheduledReportsApi } = await import('./reportsApi');
    return await scheduledReportsApi.deactivateScheduledReport(id);
  },

  /**
   * Run a scheduled report immediately
   */
  runScheduleNow: async (id: number) => {
    const { scheduledReportsApi } = await import('./reportsApi');
    return await scheduledReportsApi.runScheduledReportNow(id);
  },

  /**
   * Get all schedules
   */
  listSchedules: async (params?: any) => {
    const { scheduledReportsApi } = await import('./reportsApi');
    return await scheduledReportsApi.listScheduledReports(params);
  },

  /**
   * Get schedule detail
   */
  getSchedule: async (id: number) => {
    const { scheduledReportsApi } = await import('./reportsApi');
    return await scheduledReportsApi.getScheduledReport(id);
  },
};
